// extracted by mini-css-extract-plugin
module.exports = {"limitedText":"ReadFullNote_limitedText__1zCJW","overflowing":"ReadFullNote_overflowing__2iXYB"};